import React, { ReactElement } from 'react';
import {
  SkeletonCardContainer,
  SkeletonImage,
  SkeletonContent,
} from './SkeletonCard.styled';
import { SkeletonLoaderText } from '@feast-it/ui/light';

export function SkeletonCard(): ReactElement {
  return (
    <SkeletonCardContainer>
      <SkeletonImage height={250} width={250} />
      <SkeletonContent>
        <SkeletonLoaderText height={20} rows={2} isLastRowHalfWidth />
      </SkeletonContent>
    </SkeletonCardContainer>
  );
}
